export const DEFAULT_COL_WIDTH = 150;
export const MIN_COL_WIDTH = 50;

export const AP_SCHEDULE_PAGE_SIZE = 125;
export const AP_SCHEDULE_MAX_PAGES_IN_CACHE = 10;
export const AP_SCHEDULE_BLOCK_LOAD_DEBOUNCE = 0;
export const AP_SCHEDULE_GRID_INITIAL_ROW_COUNT = 1;
export const AP_SCHEDULE_MIN_SEARCH_LENGTH = 2;
